import { coins, marketDate } from '../format';
import { useState } from 'react';
import { Link } from 'react-router';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { useAuth } from '@/features/auth/use-auth';
import { useAuthDialog } from '@/features/auth/use-auth-dialog';
import { useGeeCoinTransactions } from '../api';
import {
  AccountStrip,
  CoinMark,
  LoadError,
  MarketHero,
  Pagination,
} from '../components/MarketParts';

export function GeeCoinPage() {
  const { isAuthenticated, isLoading } = useAuth();
  const { open } = useAuthDialog();
  const [page, setPage] = useState(1);
  const transactions = useGeeCoinTransactions(page);
  return (
    <div className="market-page">
      <MarketHero coinPage />
      <AccountStrip detailed />
      <section className="gc-how" aria-labelledby="gc-how-title">
        <div className="market-section-heading">
          <div>
            <p className="market-eyebrow">BİRLİKTE DAHA GÜZEL</p>
            <h2 id="gc-how-title">GeeCoin nasıl çalışır?</h2>
          </div>
          <span className="market-outline-label">Topluluk puanı</span>
        </div>
        <ol className="gc-steps">
          <li>
            <span className="gc-step-number">01</span>
            <h3>Etkinliklere katıl</h3>
            <p>
              GeeFamily topluluk etkinliklerini takip et. Katılım ve ödül koşulları her etkinlikte
              ayrıca duyurulur.
            </p>
          </li>
          <li>
            <span className="gc-step-number">02</span>
            <h3>GeeCoin biriktir</h3>
            <p>
              Etkinlik ödüllerin ekip tarafından eklenir. Milestone hedeflerine ulaştığında
              sandığını açarak puanlarını al; tüm kazanımlarını hesap hareketlerinde gör.
            </p>
          </li>
          <li>
            <span className="gc-step-number">03</span>
            <h3>Market’te kullan</h3>
            <p>
              Ürününü seç, GeeCoin tutarını onayla. Siparişinin durumunu ve teslimat notunu
              Market’ten takip et.
            </p>
          </li>
        </ol>
        <p className="gc-policy">
          <CoinMark small /> GeeCoin satın alınamaz, başka hesaba aktarılamaz ve nakde çevrilemez.
          Yalnızca GeeFamily Market’te kullanılır.
        </p>
      </section>
      <section id="geecoin-history" className="market-history" aria-labelledby="gc-history-title">
        <div className="market-section-heading">
          <div>
            <p className="market-eyebrow">HER PUANIN BİR HİKÂYESİ VAR</p>
            <h2 id="gc-history-title">Hesap hareketleri</h2>
          </div>
          <Link to="/market" className="market-text-link">
            Market’e git ↗
          </Link>
        </div>
        {isLoading ? (
          <p role="status" className="market-loading">
            Oturum kontrol ediliyor…
          </p>
        ) : !isAuthenticated ? (
          <EmptyState
            title="GeeCoin hesabını keşfet"
            description="Bakiyeni ve hesap hareketlerini görmek için giriş yap."
          >
            <Button className="mt-5" onClick={() => open('login')}>
              Hesabına giriş yap
            </Button>
          </EmptyState>
        ) : transactions.isPending ? (
          <p role="status" className="market-loading">
            Hesap hareketleri yükleniyor…
          </p>
        ) : transactions.isError ? (
          <LoadError
            retry={() => {
              void transactions.refetch();
            }}
          />
        ) : transactions.data.rows.length === 0 ? (
          <EmptyState
            title="Henüz bir hesap hareketin yok"
            description="İlk etkinlik ödülün hesabına eklendiğinde burada görünecek."
          />
        ) : (
          <>
            <ul className="gc-ledger">
              {transactions.data.rows.map((row) => (
                <li key={row.id}>
                  <span className={`gc-ledger-icon gc-ledger-${row.kind}`} aria-hidden>
                    {row.kind === 'spend' ? '↗' : '↙'}
                  </span>
                  <div className="gc-ledger-copy">
                    <p>{row.reason}</p>
                    <div>
                      <span>
                        {row.kind === 'milestone'
                          ? 'Milestone ödülü'
                          : row.kind === 'award'
                            ? 'Etkinlik ödülü'
                            : row.kind === 'refund'
                              ? 'Sipariş iadesi'
                              : 'Market siparişi'}
                      </span>
                      <time dateTime={row.createdAtUtc}>{marketDate(row.createdAtUtc)}</time>
                    </div>
                    {row.kind === 'milestone' ? (
                      <Link to="/milestone-rewards" className="market-text-link">
                        Milestone adalarım ↗
                      </Link>
                    ) : null}
                    {row.orderId ? (
                      <Link to="/market#market-orders" className="market-text-link">
                        Siparişlerim ↗
                      </Link>
                    ) : null}
                  </div>
                  <strong className={row.amount > 0 ? 'gc-positive' : ''}>
                    {row.amount > 0 ? '+' : ''}
                    {coins(row.amount)} <small>GC</small>
                  </strong>
                </li>
              ))}
            </ul>
            <Pagination
              page={transactions.data.page}
              pageSize={transactions.data.pageSize}
              totalCount={transactions.data.totalCount}
              onPage={setPage}
            />
          </>
        )}
      </section>
    </div>
  );
}
